import { Injectable, inject, Injector } from "@angular/core";
import { FILTER_REGISTRY } from "./filter.tokens";
import type { FilterViewTypeEnum, FilterField } from "./filter.types";
import type { ApplicationTag } from "@app/views-interfaces";

@Injectable()
export class FilterRegistrationResolver {
    private readonly injector = inject(Injector);
    private readonly registrations = inject(FILTER_REGISTRY, { optional: true }) ?? [];

    public get(applicationTag: ApplicationTag, viewType: FilterViewTypeEnum): FilterField<any>[] {
        return this.registrations
            .filter((x) => x.applications.includes(applicationTag) && x.viewTypes.includes(viewType))
            .map((x) => this.injector.get(x.service));
    }
}
